function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m0 0v512h512v-512zm482 482h-452v-452h452zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m256 451c107.523438 0 195-87.476562 195-195s-87.476562-195-195-195-195 87.476562-195 195 87.476562 195 195 195zm-15-30.6875v-29.3125h30v29.3125c-4.941406.445312-9.941406.6875-15 .6875s-10.058594-.242188-15-.6875zm30-328.625v29.3125h-30v-29.3125c4.941406-.445312 9.941406-.6875 15-.6875s10.058594.242188 15 .6875zm-60 5.550781v53.761719h90v-53.761719c69.179688 19.636719 120 83.375 120 158.761719s-50.820312 139.125-120 158.761719v-53.761719h-90v53.761719c-69.179688-19.636719-120-83.375-120-158.761719s50.820312-139.125 120-158.761719zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m346 301c24.8125 0 45-20.1875 45-45s-20.1875-45-45-45-45 20.1875-45 45 20.1875 45 45 45zm0-60c8.269531 0 15 6.730469 15 15s-6.730469 15-15 15-15-6.730469-15-15 6.730469-15 15-15zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m211 256c0-24.8125-20.1875-45-45-45s-45 20.1875-45 45 20.1875 45 45 45 45-20.1875 45-45zm-60 0c0-8.269531 6.730469-15 15-15s15 6.730469 15 15-6.730469 15-15 15-15-6.730469-15-15zm0 0"
});

function Svg22(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg22);
export default __webpack_public_path__ + "static/media/2_2.bfa90fef.svg";
export { ForwardRef as ReactComponent };